export default {
  'Sample photo': 'Contoh foto',
  Removing: 'Menghapus',
  Edit: 'Sunting',
  'Adjust Picture': 'Sesuaikan Gambar',
  Restore: 'Pulihkan',
  Eraser: 'Penghapus',
  Size: 'Ukuran',
  Background: 'Latar belakang',
  Custom: 'Sesuaikan',
  Presets: 'Preset',
  'Add Image': 'Tambah gambar',
  'Scale to Fit': 'Skala agar Sesuai',
  'Full Width': 'Lebar Penuh',
  'Full Height': 'Tinggi Penuh',
  Move: 'Pindah',
  Undo: 'Undo',
  Redo: 'Redo',
  Enlarge: 'Pperbesar',
  Reduce: 'Perkecil',
  //2022.09.28 xxy
  BGRemover: {
    title: 'Penghapus Latar Belakang Online HitPaw',
    desc: 'Hapus latar belakang foto Anda dengan mudah 100% Secara Otomatis & Gratis',
    imgAlt: 'photo background remover',
    submitBtn: 'Hapus Latar Belakang',
  },
  BGChanger: {
    title: 'HitPaw Photo Background Changer',
    desc: 'Extremely easy to change photo background 100% automatically & free',
    imgAlt: 'photo background change',
    submitBtn: 'Change Background',
  },
  "Shadows" : "Bayangan",
  "Intensity" : "Kegelapan",
  "Radius" : "Radius",
  "Color" : "Warna",
  "Move" : "Bergerak",
  "2D move" : "2D",
  "3D move" : "3D",
  "Move the shadow" : "Seret bayangan di sekitar gambar",
    "Upload failed, click to try again": "Upload gagal, klik untuk mencoba lagi",
};
